import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import MuiImageList from '@mui/material/ImageList';
import screenSize, { SIZE } from 'ripple/Utils/screenSize';
import styles from 'ripple/Components/GridList/GridList.scss';

export const GRID_COLS = {
  [SIZE.XS]: 2,
  [SIZE.SM]: 3,
  [SIZE.MD]: 4,
  [SIZE.LG]: 5,
  [SIZE.XL]: 6,
};
const ImageList = ({ children, rowHeight = 'auto', flexy, ...props }) => {
  const size = screenSize();
  const [columns, setCols] = useState(5);

  useEffect(() => {
    setCols(GRID_COLS[size]);
  }, [size]);

  return (
    <MuiImageList
      classes={flexy ? {} : { root: styles.gridList }}
      sx={
        flexy
          ? {
              gridAutoFlow: 'column',
              gridTemplateColumns: `repeat(${columns}, minmax(${97
                / columns}%, 1fr)) !important`,
              gridAutoColumns: `minmax(${97 / columns}%, 1fr) !important`,
            }
          : {}
      }
      rowHeight={rowHeight}
      {...props}
      cols={columns}
    >
      {children}
    </MuiImageList>
  );
};

ImageList.propTypes = {
  flexy: PropTypes.bool,
  rowHeight: PropTypes.number,
  children: PropTypes.node.isRequired,
  cols: PropTypes.number,
};

export default ImageList;
